export enum FileType {
  UNKNOWN,
  XLSX,
  PDF,
  CSV,
  DOCX,
  IMAGE,
  TXT,
  JSON,
  KML,
  PPTX,
  SHP,
  ZIP,
  JPEG,
  JPG,
  PNG,
  PYTHON,
  MAP,
  LINES,
  POINTS,
  POLYGON,
  TABLE,
  RASTER,
  WMS,
  ARCGIS,
  XYZ,
  PostreSQL,
  PostgresSchema,
  AmazonS3,
  ArcGISServer,
  ArcGISMapServer,
  ArcGISFeatureServer,
}

export const CATALOG_RESOURCE_TYPES = [
  FileType.MAP,
  FileType.LINES,
  FileType.POINTS,
  FileType.POLYGON,
  FileType.TABLE,
  FileType.RASTER,
  FileType.WMS,
  FileType.ARCGIS,
  FileType.XYZ,
];

export const DATA_SOURCE_TYPES = [
  FileType.PostreSQL,
  FileType.PostgresSchema,
  FileType.AmazonS3,
  FileType.ArcGISServer,
  FileType.ArcGISFeatureServer,
  FileType.ArcGISMapServer,
];

export const DATA_SOURCE_RESOURCE_TYPES = [
  FileType.PostgresSchema,
  FileType.ArcGISFeatureServer,
  FileType.ArcGISMapServer,
];

export const JPG_MIME_TYPE = "image/jpeg";
export const PNG_MIME_TYPE = "image/png";

export const IMAGE_MIME_TYPES = [
  "image/apng",
  "image/avif",
  "image/gif",
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/webp",
];

export const XLSX_MIME_TYPES = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const PDF_MIME_TYPE = "application/pdf";

export const DOCX_MIME_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const CSV_MIME_TYPE = "text/csv";

export const JSON_MIME_TYPE = "application/json";

export const TXT_MIME_TYPE = "text/plain";

export const PPTX_MIME_TYPES = [
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const SHP_MIME_TYPE = "application/octet-stream";
export const KML_MIME_TYPE = "application/octet-stream";

export const ZIP_MIME_TYPE = "application/zip";

export const PYTHON_MIME_TYPES = ["application/x-python-code", "text/x-python"];

export const IMAGE_FILE_TYPES = [FileType.IMAGE, FileType.JPEG, FileType.JPG, FileType.PNG];
